import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { ApplicationConfig } from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from "@angular/router";
import Aura from "@primeng/themes/aura";
import { providePrimeNG } from "primeng/config";
import { appRoutes } from "./app.routes";
import { TokenInterceptor } from "./app/interceptors/token.interceptor";
import { UploadProgressInterceptor } from "./app/interceptors/upload-progress.interceptor";
import { environment } from "./environments/environment";
import { provideFirebaseApp, initializeApp } from "@angular/fire/app";
import { provideAuth, getAuth } from "@angular/fire/auth";
import { MessageService } from "primeng/api";
import { provideQuillConfig } from "ngx-quill";
import { provideHighlightOptions } from "ngx-highlightjs";
import { provideNgxStripe } from "ngx-stripe";
import { CustomClipboardService } from "./app/shared/quill/custom-clipboard.service";
import Quill from "quill";
import QuillCursors from "quill-cursors";

// Enregistrer le module cursors globalement AVANT que ngx-quill ne charge Quill
Quill.register("modules/cursors", QuillCursors);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
      }),
      withEnabledBlockingInitialNavigation(),
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: ".app-dark",
        },
      },
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    // Enregistré APRÈS TokenInterceptor : il doit recevoir la requête déjà
    // authentifiée pour la router vers le backend XHR (progression d'upload).
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UploadProgressInterceptor,
      multi: true,
    },
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    MessageService,
    provideQuillConfig({
      modules: {
        cursors: {
          template:
            '<div class="cursor-flag"><span class="cursor-name"></span></div>',
          hideDelayMs: 5000,
        },
        toolbar: [
          ["bold", "italic", "underline", "strike"], // Styles de texte
          ["blockquote"], // Citation et bloc code

          [{ header: 1 }, { header: 2 }], // Titres H1, H2
          [{ list: "ordered" }, { list: "bullet" }], // Listes
          [{ script: "sub" }, { script: "super" }], // Indices
          [{ indent: "-1" }, { indent: "+1" }], // Indentation
          [{ direction: "rtl" }], // Direction RTL

          [{ size: ["small", false, "large", "huge"] }], // Tailles de police

          // Font family est retiré ici

          [{ header: [1, 2, 3, 4, 5, 6, false] }], // Niveaux de titre
          [{ color: [] }, { background: [] }], // Couleurs texte/fond
          [{ align: [] }], // Alignement

          ["clean"], // Supprimer la mise en forme

          ["link"], // Garder les liens
          // Pas de 'image' ni 'video'
        ],
      },
      theme: "snow",
      customModules: [
        {
          path: "modules/clipboard",
          implementation: CustomClipboardService.getCustomClipboardClass(),
        },
      ],
    }),
    provideHighlightOptions({
      fullLibraryLoader: () => import("highlight.js"),
    }),
    provideNgxStripe(),
  ],
};
